import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import AgenteIaRestaurante from "@/pages/AgenteIaRestaurante";

export const Route = createFileRoute("/agente-ia-restaurante")({
  head: () => buildHead({
    title: "Agente de IA para Restaurante: pedidos no WhatsApp sem fila",
    description: "Agente de IA que recebe pedidos no WhatsApp e no Instagram, sugere combos, confirma entrega e traz o cliente de volta. 24h, com CRM incluso.",
    path: "/agente-ia-restaurante",
  }),
  component: AgenteIaRestaurante,
});
